import React from 'react';
import { LayoutInternal } from '@/layout';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { TitleFeatured } from '@/components/typography';
import { CardBody, CardFeatured, CardFooter, CardTitle } from '@/components/card';
import { urlPacotes } from '@/config/url';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import { GridContainer } from './ViagensList.styles';
import FilterListItems from '@/features/pacote/components/FilterListItems/FilterListItems';
import { useTranslations } from 'next-intl';
import CardMedia from '@/components/card/CardMedia/CardMedia';

export interface ViagensListProps {
  data: ViagemPageDataType;
}

const ViagensList = ({ data }: ViagensListProps) => {
  const t = useTranslations('Viagem');

  const { page } = data;
  const breadcrumbs: BreadcrumbType = [
    { path: '/viagens', text: page.category.title },
    { path: page.slug, text: page.title },
  ];

  const parseLink = (slug: string, travelTypeSlug: string) => {
    return urlPacotes(slug, travelTypeSlug);
  };

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} mediaCover={page.cover}>
      <WhitePaper col={12}>
        <TitleFeatured as="h1" title={page.title} description={page.description} />
      </WhitePaper>
      <WhitePaper col={12}>
        <FilterListItems placeholder={t('Filtrar Destinos')} initialData={page.destinos}>
          {({ data }) => (
            <GridContainer>
              {data.map(({ slug, title, summary, media }, index) => (
                <CardFeatured key={`${slug}-${index}`}>
                  <CardMedia
                    media={media}
                    href={parseLink(slug, page.slug)}
                    priority={index <= 1}
                    mediaOptions={{ featured: true }}
                  />
                  <CardTitle as="h2" textCase="uppercase">
                    <Link href={parseLink(slug, page.slug)}>{title}</Link>
                  </CardTitle>
                  <CardBody>{summary}</CardBody>
                  <CardFooter>
                    <Button href={parseLink(slug, page.slug)} block arrow>
                      {slug === 'crie-seu-roteiro' ? t('Crie Seu Roteiro') : `${t('Viagens')} ${title}`}
                    </Button>
                  </CardFooter>
                </CardFeatured>
              ))}
            </GridContainer>
          )}
        </FilterListItems>
      </WhitePaper>
    </LayoutInternal>
  );
};

export default ViagensList;
